import { mount } from 'svelte';
import MainApp from './MainApp.svelte';

const app = mount(MainApp, { target: document.body});

export default app;